// extracted by mini-css-extract-plugin
export var statItem = "_hr-1";
export var statsRow = "_hr-0";